module.exports = __webpack_public_path__ + "static/img/pggsnv.b94594a3.png";